/**
 * App-specific localization constants.
 */
import { getLocaleInfo } from '@vestigas/utils';

import { dayjs } from './datetime';
import { currentLocale } from './i18n';

// Date format constants (app-specific, used with dayjs)
export const date4server = 'YYYY-MM-DD';
export const dateLocalizedShort = 'DD.MM.YY';
export const dateLocalizedShortest = 'DD.MM.YY';
export const dateLocalizedWMonthName = 'DD. MMMM YYYY';
export const dateLocalizedWOYear = 'DD. MMMM';
export const dateLocalizedWOYearShort = 'D.M.';
export const dateFull = 'DD.MM.YYYY';
export const dateFullDay = 'dddd, DD.MM.YYYY';
export const dateFullDayShort = 'dd, DD.MM.YYYY';
export const dateLong = 'DD.MM.YYYY';
export const dateMonthYear = 'M/YYYY';
export const dateMonthYearLong = 'MMMM YYYY';
export const dateMonthYearShort = 'M/YY';
export const datetime4server = "YYYY-MM-DD'T'HH:mm:ss'Z'";
export const datetime4datetimeInput = "YYYY-MM-DD'T'HH:mm";
export const timeHours = 'HH';
export const time24h = 'H:mm';

// App-specific locale information (depends on i18n and dayjs)
// Uses validated getLocaleInfo which handles non-standard separators (e.g., NBSP, apostrophe)
const locale = currentLocale();
const { decimal, thousand } = getLocaleInfo(locale);

/**
 * Locale information for the current app locale.
 * This includes validated decimal/thousand separators and weekday names from dayjs.
 */
export const LOCALE_INFO = {
  decimal,
  name: locale,
  thousand,
  weekdayNames: dayjs.weekdays(),
  weekdayNamesShort: dayjs.weekdaysMin(),
};
